export default __webpack_public_path__ + "web/src/assets/images/billing/visa-logo.png?[fullhash]";